exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-dialog .el-dialog__body[data-v-2d814b64]{padding-top:5px;padding-bottom:10px}\n", ""]);

// exports
